import React from 'react';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import useStyles from './PatrolBody.styles';
import FindingList from '../../../../finding/components/list/FindingList';
import PatrolDetails from './PatrolDetails';
import { PatrolExact } from '../../../models/Patrol';
import { FindingShape } from '../../../../finding/models/Finding';

const initialValues = {
  exactFindingId: '',
  findingType: [],
  findingClass: [],
  hideRegularPassengerVehicles: true,
};

const PatrolBody = ({ patrol, findings, onFiltersChange, onFindingUpdate, isFetchingFindings }) => {
  const classes = useStyles();

  return (
    <Formik initialValues={initialValues} onSubmit={onFiltersChange}>
      {() => (
        <Form>
          <div className={classes.root}>
            <PatrolDetails patrol={patrol} findings={findings} isFetchingFindings={isFetchingFindings} />
            <FindingList
              patrolId={patrol.id}
              findings={findings}
              clientCategories={patrol.clientCategories}
              onFindingUpdate={onFindingUpdate}
              isFetchingFindings={isFetchingFindings}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

PatrolBody.propTypes = {
  patrol: PatrolExact.isRequired,
  findings: PropTypes.arrayOf(FindingShape).isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  onFindingUpdate: PropTypes.func.isRequired,
  isFetchingFindings: PropTypes.bool.isRequired,
};

PatrolBody.defaultProps = {};

export default PatrolBody;
